import React from 'react';
import Button  from '../../common/components/button';
import '../style/app-download.scss';

//TODO: Note: This may not be the best place for the page, but it is the best fit today.
const AppDownload = props => {
	return (
		<div className="default-content-layout right-side">
			<div className="my-app-download-container">
				<div className="manage-container all-os">
					<h1>App Downloads</h1>
						<div className="app-mobile">
						<div className="app-download-iphone"></div>
						<div className="app-download-android"></div>
						<h2>iPhone/iPad or Android</h2>
						<p>
							Automatically upload photos and videos from your iPhone, iPad, or Android devices, PLUS view and share.
						</p>
						<a href="https://itunes.apple.com/us/app/imemories/id528388477?mt=8" target="_blank" rel="noopener noreferrer" className="btn-app-store"> </a>
						<a href="https://play.google.com/store/apps/details?id=com.imemories.android&feature=search_result#?t=W251bGwsMSwxLDEsImNvbS5pbWVtb3JpZXMuYW5kcm9pZCJd" target="_blank" rel="noopener noreferrer" className="btn-google-play"> </a>
					</div>
					<div className="app-desktop">
						<div className="desktop-download-mac"></div>
						<div className="desktop-download-pc"></div>
						<h2>Mac or PC</h2>
						<p>
							Automatically upload photos and videos from your Mac or PC, USB Drives, connected cameras, and SD cards.
						</p>
                        <Button href="#win" target="_blank" rel="noopener noreferrer" buttonStyle="secondary" className="btn-red" buttonLabel="Auto-Uploader for Windows" />
						<p>
							Windows 10+
						</p>
                        <Button href="#mac" target="_blank" rel="noopener noreferrer" buttonStyle="secondary" className="btn-blue" buttonLabel="Auto-Uploader for Mac" />
						<p>
							OSX High Sierra
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AppDownload;


// WEBPACK FOOTER //
// ./src/static/components/app-download.jsx